export const Spinner = () => {
    return (
        <div className="flex items-center justify-center">
            <svg
                width="461"
                height="362"
                viewBox="0 0 461 362"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="visually-hidden animate-spin-slow w-12"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M460.223 0H279.301L230 180.921H410.921L460.223 0ZM230.223 181H49.3011L0 361.921H180.921L230.223 181Z"
                    fill="#282828"
                />
            </svg>
        </div>
    );
};

export const FullPageSpinner = () => {
    return (
        <div className="flex h-screen w-screen items-center justify-center">
            <Spinner />
        </div>
    );
};
